import { api } from "@/api";

const tillsStore = {
  state: {
    tills: [],
    deposits: []
  },
  getters: {
    getTills(state) {
      return state.tills;
    },
    getDeposits(state) {
      return state.deposits;
    }
  },
  mutations: {
    setTills(state, payload) {
      state.tills = payload;
    },
    setDeposits(state, payload) {
      state.deposits = payload;
    }
  },
  actions: {
    async loadTills({ commit }) {
      const res = await api.getTills();
      commit("setTills", res);
    },
    async loadDeposits({ commit }) {
      const res = await api.getDeposits();
      commit("setDeposits", res);
    }
  }
};

export default tillsStore;
